import { render } from "./Farmer.vue?vue&type=template&id=416b1d2e&ts=true"
import script from "./Farmer.vue?vue&type=script&lang=ts"
export * from "./Farmer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\friendly-fox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__